import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// A dedicated axios instance that always sends the admin httpOnly cookie.
// We deliberately DO NOT store the JWT in localStorage or JS memory — the
// browser handles it opaquely via the cookie, so an XSS attacker can't
// exfiltrate it.
const adminAxios = axios.create({ baseURL: API, withCredentials: true });

export async function adminLogin(email, password) {
  // Server sets the httpOnly `mrd_admin_token` cookie in its response.
  const res = await adminAxios.post("/admin/login", { email, password });
  return res.data;
}

export async function adminLogout() {
  try {
    await adminAxios.post("/admin/logout");
  } catch (e) {
    /* even if the server didn't clear the cookie, the client can't help */
  }
}

export async function adminMe() {
  const res = await adminAxios.get("/admin/me");
  return res.data;
}

// True iff the current browser is authenticated as an admin. Uses a lightweight
// `/admin/me` probe — returning `false` for any non-2xx (including 401).
export async function isAdminAuthenticated() {
  try {
    await adminMe();
    return true;
  } catch (e) {
    return false;
  }
}

// GET /api/admin/downloads?from=&to=&kind=&limit=
export async function fetchDownloads({ from, to, kind, limit = 1000 } = {}) {
  const params = {};
  if (from) params.from_ = from;
  if (to) params.to = to;
  if (kind) params.kind = kind;
  if (limit) params.limit = limit;
  const res = await adminAxios.get("/admin/downloads", { params });
  return res.data;
}

// Public: track any successful PDF download (called from Builder after runDownload).
export async function trackDownload(payload) {
  try {
    await axios.post(`${API}/downloads/track`, payload);
  } catch (e) {
    // Non-critical — never let analytics failure break the download UX.
    console.warn("trackDownload failed", e);
  }
}

// GET /api/config/limits → { paid_download_limit, free_download_limit }
export async function getLimits() {
  const res = await axios.get(`${API}/config/limits`);
  return res.data;
}

export async function fetchDiscount() {
  const res = await adminAxios.get("/admin/discount");
  return res.data;
}

export async function updateDiscount(payload) {
  const res = await adminAxios.put("/admin/discount", payload);
  return res.data;
}

// -------- Contact form (public + admin) -------------------------------------
export async function submitContact(payload, { honeypot, mountTs } = {}) {
  const res = await axios.post(`${API}/contact`, payload, {
    headers: {
      "X-Mrd-Hp": honeypot || "",
      "X-Mrd-Ts": mountTs ? String(mountTs) : "",
    },
  });
  return res.data;
}

export async function fetchContactMessages() {
  const res = await adminAxios.get("/admin/contact-messages");
  return res.data;
}

export async function updateContactMessageStatus(id, status) {
  const res = await adminAxios.patch(`/admin/contact-messages/${id}`, { status });
  return res.data;
}
